<template>
  <div  v-if="atual.texto">
    <div class="container editor mt-12" v-html="atual.texto"></div>
  </div>
</template>

<script>
export default {
  props: {
    atual:{
      type:Object,
    }
  },
};
</script>

<style scoped>

</style>
